// extracted by mini-css-extract-plugin
module.exports = {"container":"nav_item-module__container--1x6s5"};